import React from "react";
import { ReporteChequeo } from "../../../../models/ReporteChequeo";
import {
  logsCheckModalUi as S,
  parseCheckCoords,
  hasValidCoords,
} from "./logsCheckModalUi.ts";

const AccordionCheck = ({ check }: { no?: number; check: ReporteChequeo }) => {
  const [expanded, setExpanded] = React.useState(false);
  const coords = React.useMemo(
    () => parseCheckCoords(check.assistanceCheck_coords),
    [check.assistanceCheck_coords]
  );
  const withLocation = hasValidCoords(coords);

  const headerContent = (
    <>
      <div className="d-flex align-items-center gap-3 flex-wrap">
        <span style={S.time}>{check.assistanceCheck_checkTime}</span>
        {withLocation ? (
          <span style={S.badgeOk}>
            <i className="fa-solid fa-location-dot" aria-hidden />
            Con ubicación
          </span>
        ) : (
          <span style={S.badgeWarn}>
            <i className="fa-solid fa-location-crosshairs" aria-hidden />
            Sin coordenadas
          </span>
        )}
      </div>
      {withLocation && (
        <i
          className={`fa-solid fa-chevron-down ${expanded ? "" : ""}`}
          style={{
            ...S.chevron,
            transform: expanded ? "rotate(180deg)" : "rotate(0deg)",
          }}
          aria-hidden
        />
      )}
    </>
  );

  return (
    <div style={S.item}>
      {withLocation ? (
        <button
          type="button"
          style={S.itemHeader}
          onClick={() => setExpanded((v) => !v)}
          aria-expanded={expanded}
        >
          {headerContent}
        </button>
      ) : (
        <div style={S.itemHeaderStatic}>{headerContent}</div>
      )}

      {withLocation && expanded && (
        <div style={S.mapWrap}>
          <iframe
            title={`Mapa registro ${check.assistanceCheck_id}`}
            style={S.mapFrame}
            src={`https://www.google.com/maps?q=${coords.latitude},${coords.longitude}&z=15&output=embed`}
            allowFullScreen
          />
        </div>
      )}
    </div>
  );
};

export default AccordionCheck;
